import { ref } from 'vue'

export const pageTitle = ref('')